import React from 'react';
import { ArrowRight } from 'lucide-react';
import Container from './Container';
import Button from './Button';

const CallToAction: React.FC = () => {
  return (
    <section className="bg-gradient-to-tr from-primary/10 via-background to-secondary/10 py-16 md:py-24" id='CalltoAction'>
      <Container>
        <div className="mx-auto max-w-3xl text-center">
          <h2 className="mb-6 text-3xl font-bold sm:text-4xl md:text-5xl">
            Ready to Create Your First Game?
          </h2>
          
          <p className="mb-8 text-lg text-muted-foreground">
            Join the waitlist today and be among the first to access our AI-powered game development platform. No coding required — just your creativity!
          </p>
          
          <div className="flex flex-col items-center justify-center space-y-4 sm:flex-row sm:space-x-4 sm:space-y-0">
            <div className="relative w-full max-w-md rounded-md">
              <div className="absolute -inset-0.5 rounded-lg bg-gradient-to-r from-primary to-secondary opacity-30 blur"></div>
              <div className="relative">
                <input
                  type="email"
                  placeholder="Enter your email"
                  className="w-full rounded-md border border-border bg-background py-3 pl-4 pr-10 text-foreground focus:border-primary focus:outline-none focus:ring-2 focus:ring-primary/20"
                />
              </div>
            </div>
            
            <Button size="lg">
              Join Waitlist
              <ArrowRight className="ml-2 h-4 w-4" />
            </Button>
          </div>
          
          <p className="mt-4 text-sm text-muted-foreground">
            By joining, you agree to our Terms of Service and Privacy Policy.
          </p>
        </div>
      </Container>
    </section>
  );
};

export default CallToAction;